module.exports = __webpack_public_path__ + "img/213.81e9129d.jpg";